import baseURL from './url'; // Asegúrate de importar tu URL base

let usuario = null;

export const fetchUsuario = async () => {
    try {
        const response = await fetch(`${baseURL}/userLogued.php`, {
            credentials: 'include' // IMPORTANTE: Enviar/Recibir cookies de sesión
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        usuario = await response.json();
        
        // Si hay un error de sesión, intentar recuperar de localStorage
        if (usuario?.error) {
            const localUser = localStorage.getItem('usuario');
            if (localUser) {
                usuario = JSON.parse(localUser);
            }
        } else if (usuario?.idUsuario) {
            // Si la sesión es válida, actualizar localStorage
            localStorage.setItem('usuario', JSON.stringify(usuario));
        }

    } catch (error) {
        console.error('Error al obtener datos del usuario:', error);
        // Fallback final a localStorage
        const localUser = localStorage.getItem('usuario');
        usuario = localUser ? JSON.parse(localUser) : null;
    }
};

export const getUsuario = () => {
    return usuario; // Devuelve los datos del usuario
};
